class EfdList {
  constructor(gql, modal, scope) {
    this.apply = (fn) => scope.$apply(fn)
    this.gql = gql
    this.modal = modal
  }

  $onChanges({ filter }) {
    if (filter) {
      if (filter.currentValue) {
        this.filter = filter.currentValue
        this.loadingPromise = this.loadEfds()
      } else {
        this.efds = null
      }
    }
  }

  get finalidadeDescricao() {
    return { '0': 'substituto', '1': 'original' }
  }

  async loadEfds() {
    const { contrato: { efds } } = await this.listEfds({ empresaId: this.contratoId, filter: this.filter })

    this.apply(() => this.efds = efds)
  }

  async listEfds(variables) {
    const query = gql`
      query Efds($empresaId: Int!, $filter: EfdFilter!) {
        contrato: empresa(id: $empresaId) {
          id
          efds(filter: $filter) {
            id
            tipo
            versao
            finalidade
            dataInicio
            dataFim
            dataReferencia
            dataEnvio
            # alertasTotalCount
            filial {
              id
              produtosContrataveis
            }
          }
        }
      }
    `

    return await this.gql.query(query, variables)
  }

  async download(efd) {
    const tab = cbk.initDownloadTab();

    const query = gql`
      query DownloadEfd($empresaId: Int!, $efdId: Int!) {
        contrato: empresa(id: $empresaId) {
          id
          efd: downloadEfd(id: $efdId) {
            token
          }
        }
      }
    `

    const variables = { empresaId: this.contratoId, efdId: efd.id.toInt() }
    const { contrato: { efd: { token } } } = await this.gql.query(query, variables)

    cbk.download(`/api/resume-operation/${token}`, tab)
  }

  openAlertas(efd) {
    this.onOpenAlertas({ efd })
  }
}

angular.module("eficienciaFiscalModule").component("efdList", {
  controller: ["gql", "$uibModal", "$scope", EfdList],
  bindings: {
    filter: '<',
    contratoId: '<',
    onOpenAlertas: '&'
  },
  template: `
    <loading promise="$ctrl.loadingPromise">
      <highlighted ng-show="$ctrl.efds.length == 0">
        <main>Nenhum arquivo encontrado.</main>
      </highlighted>
      <div ng-show="$ctrl.efds.length > 0" style="margin-top: 5px">
        <table class="table no-margin">
          <thead>
            <tr>
              <th class="text-center" width="1">#</th>
              <th>Mês</th>
              <th>Finalidade</th>
              <th>Data inicial</th>
              <th>Data final</th>
              <th>Data do envio</th>
              <th width="1">Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-middle" ng-repeat="efd in $ctrl.efds">
              <td class="text-center-middle">{{ $index + 1 }}</td>
              <td>{{ efd.dataReferencia | date: "MMMM 'de' yyyy" }}</td>
              <td>Remessa do arquivo {{ $ctrl.finalidadeDescricao[efd.finalidade] }}</td>
              <td>{{ efd.dataInicio | date }}</td>
              <td>{{ efd.dataFim | date }}</td>
              <td>{{ efd.dataEnvio | date }}</td>
              <td class="no-break">
                <a ng-click="$ctrl.download(efd)">Baixar</a>

                <!--<br ng-if="efd.filial.produtosContrataveis.includes('alertas-efd')" />
                  <a ng-if="efd.filial.produtosContrataveis.includes('alertas-efd')" ng-click="$ctrl.openAlertas(efd)">
                  Alertas <span ng-if="efd.alertasTotalCount">({{ efd.alertasTotalCount }})</span>
                </a>-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </loading>
  `
})
